import React from 'react';

export interface ISkeletonContext {
  /**
   * Input states
   */
  focused?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  error?: boolean;
}

const skeletonContext = React.createContext<ISkeletonContext>({});

export const SkeletonContextProvider = skeletonContext.Provider;
export const SkeletonContextConsumer = skeletonContext.Consumer;
export const useSkeletonContext = () => React.useContext(skeletonContext);
